/** The HTTP status of a failed request, also when the body could not be parsed. */
export const apiErrorStatus = (error: unknown): number | undefined => {
  const { status, originalStatus } =
    (error as { status?: unknown; originalStatus?: unknown } | undefined) ?? {};
  if (typeof status === 'number') return status;
  if (typeof originalStatus === 'number') return originalStatus;
  return undefined;
};

/** A 4xx is the admin's input, shown back to them, so only other failures reach Sentry. */
export const isInputError = (error: unknown): boolean => {
  const status = apiErrorStatus(error);
  return typeof status === 'number' && status >= 400 && status < 500;
};

/** The API's own message for a failed request, or the fallback. */
export const apiErrorMessage = (error: unknown, fallback: string): string => {
  const data = (error as { data?: { message?: unknown } } | undefined)?.data;
  return typeof data?.message === 'string' ? data.message : fallback;
};
